var styles = {"label":"FormLabel-module_label__24qs9","disabled":"FormLabel-module_disabled__2NaK6","required":"FormLabel-module_required__2o5Hl"};

export { styles as default };
//# sourceMappingURL=FormLabel.module.css.js.map
